import { render, staticRenderFns } from "./button_config.vue?vue&type=template&id=d0b3a64a&scoped=true&"
import script from "./button_config.vue?vue&type=script&lang=js&"
export * from "./button_config.vue?vue&type=script&lang=js&"
import style0 from "./button_config.vue?vue&type=style&index=0&id=d0b3a64a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b3a64a",
  null
  
)

export default component.exports